export default __webpack_public_path__ + "static/media/1238.1093bd9a.png";